function initCategoryTabs(container) {
	const categoryTabs = container.querySelectorAll('.category-tabs li');
	const categoryContents = container.querySelectorAll('.category-content');

	categoryTabs.forEach((tab) => {
		tab.addEventListener('click', () => {
			// Deactivate all tabs and activate the clicked one
			categoryTabs.forEach((t) => t.classList.remove('active'));
			tab.classList.add('active');

			// Get the category name from the clicked tab
			const selectedCategory = tab.dataset.category;

			// Show all content divs that match this category
			categoryContents.forEach((content) => {
				// We check the data-category attribute instead of content.id
				const isMatch = content.dataset.category === selectedCategory;
				content.classList.toggle('active', isMatch);

				// handle display if CSS .active doesn't handle it
				content.style.display = isMatch ? 'block' : 'none';
			});
		});
	});

	// Trigger first tab
	const firstTab = categoryTabs[0];
	if (firstTab) firstTab.click();
}

// Top-level main tabs
document.querySelectorAll('.main-tab').forEach((tab) => {
	tab.addEventListener('click', () => {
		// Activate main tab
		document
			.querySelectorAll('.main-tab')
			.forEach((t) => t.classList.remove('active'));
		tab.classList.add('active');

		// Show correct tab content
		const selectedTab = tab.dataset.tab;
		document.querySelectorAll('.tab-content').forEach((content) => {
			content.style.display =
				content.id === selectedTab ? 'block' : 'none';
		});

		// Reinitialize sidebar tabs for visible tab content
		const visibleContent = document.getElementById(selectedTab);
		if (visibleContent) {
			visibleContent
				.querySelectorAll('.badge-container')
				.forEach((container) => {
					initCategoryTabs(container);
				});
		}
	});
});

// Initialize tabs on first load
document.querySelector('.main-tab.active')?.click();
